/* NS Listing — colección y búsqueda. Sustituye a assets/page-collection.js (XTRA, ~900 líneas y dependiente de
   sus globales). Marcado: sections/ns-collection.liquid, sections/ns-search.liquid y snippets/ns-listing-*.
   Filtros, orden y paginación piden la misma página con ?section_id=<sección> (API de renderizado de secciones)
   y sustituyen solo la barra, los filtros y los resultados. Si algo falla, se navega a la URL normal. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ns-listing]');
  if (!root) return;
  var sid = root.dataset.sectionId;
  var VIEW_KEY = 'ns-view';
  var ctl = null;
  var timer = null;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function parse(text) { return new DOMParser().parseFromString(text, 'text/html'); }

  /* ── Vista cuadrícula / lista (se recuerda en el navegador) ─────────────────────────── */
  function storedView() { try { return localStorage.getItem(VIEW_KEY); } catch (e) { return null; } }
  function applyView(v) {
    v = v === 'list' ? 'list' : 'grid';
    root.dataset.view = v;
    var grid = $('#collection', root);
    if (grid) grid.classList.toggle('list', v === 'list');
    $$('[data-ns-view]', root).forEach(function (b) { b.classList.toggle('is-active', b.dataset.nsView === v); });
  }

  /* ── Parámetros de la URL a partir del formulario de filtros ───────────────────────── */
  function currentParams(override) {
    var p = new URLSearchParams();
    var form = $('[data-ns-filters]', root);
    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (value === '') return;
        var input = $$('[data-ns-price]', form).filter(function (i) { return i.name === key; })[0];
        if (input && value === input.getAttribute(input.dataset.nsPrice === 'min' ? 'min' : 'max')) return; // extremo del rango = sin filtro
        p.append(key, value);
      });
    } else {
      new URLSearchParams(location.search).forEach(function (value, key) {
        if (key !== 'page' && key !== 'section_id') p.append(key, value);
      });
    }
    if (override) Object.keys(override).forEach(function (k) { p.set(k, override[k]); });
    return p;
  }
  function urlFor(p) { var q = p.toString(); return location.pathname + (q ? '?' + q : ''); }

  /* ── Petición de la sección y sustitución de las partes que cambian ───────────────── */
  function fetchSection(url) {
    if (ctl) ctl.abort();
    ctl = 'AbortController' in window ? new AbortController() : null;
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', sid);
    root.classList.add('is-loading');
    return fetch(u.pathname + u.search, ctl ? { signal: ctl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) { root.classList.remove('is-loading'); return parse(text); });
  }
  function groupState() {
    var s = {};
    $$('details[data-ns-group]', root).forEach(function (d) {
      s[d.dataset.nsGroup] = { open: d.open, more: !!$('[data-ns-list].is-expanded', d) };
    });
    return s;
  }
  function expand(d) {
    var list = $('[data-ns-list]', d), btn = $('[data-ns-showmore]', d);
    if (!list) return;
    list.classList.add('is-expanded');
    if (btn) {
      $('[data-ns-more-label="more"]', btn).hidden = true;
      $('[data-ns-more-label="less"]', btn).hidden = false;
    }
  }
  function swapParts(doc) {
    var next = $('[data-ns-listing]', doc);
    if (!next) return false;
    var state = groupState();
    ['[data-ns-bar]', '[data-ns-aside]', '[data-ns-results]'].forEach(function (sel) {
      var cur = $(sel, root), nw = $(sel, next);
      if (cur && nw) cur.innerHTML = nw.innerHTML;
    });
    $$('details[data-ns-group]', root).forEach(function (d) {
      var st = state[d.dataset.nsGroup];
      if (!st) return;
      d.open = st.open;
      if (st.more) expand(d);
    });
    applyView(root.dataset.view);
    return true;
  }
  function toTop() {
    if ($('[data-ns-aside]', root) && $('[data-ns-aside]', root).classList.contains('is-open')) return;
    var top = root.getBoundingClientRect().top;
    if (top < 0) window.scrollTo(0, top + window.pageYOffset - 150);
  }
  function go(url, push) {
    return fetchSection(url).then(function (doc) {
      if (!swapParts(doc)) { location.href = url; return; }
      if (push) history.pushState({ ns: 1 }, '', url);
      toTop();
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      root.classList.remove('is-loading');
      location.href = url;
    });
  }
  function update(override) { go(urlFor(currentParams(override)), true); }

  /* ── «Cargar más»: añade la página siguiente a la rejilla ─────────────────────────── */
  function loadMore(a) {
    if (a.classList.contains('is-loading')) return;
    a.classList.add('is-loading');
    var href = a.getAttribute('href');
    var u = new URL(href, location.origin);
    u.searchParams.set('section_id', sid);
    fetch(u.pathname + u.search)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        var doc = parse(text), grid = $('#collection', doc), cur = $('#collection', root);
        var pager = $('[data-ns-pager]', doc), curPager = $('[data-ns-pager]', root);
        if (grid && cur) while (grid.firstElementChild) cur.appendChild(grid.firstElementChild);
        if (curPager) { if (pager) curPager.innerHTML = pager.innerHTML; else curPager.remove(); }
        history.replaceState({ ns: 1 }, '', href);
      })
      .catch(function () { location.href = href; });
  }

  /* ── Cajón de filtros en móvil ────────────────────────────────────────────────────── */
  function drawer(open) {
    var aside = $('[data-ns-aside]', root), overlay = $('[data-ns-overlay]', root);
    if (!aside) return;
    aside.classList.toggle('is-open', open);
    if (overlay) overlay.classList.toggle('is-on', open);
    document.documentElement.classList.toggle('ns-lock', open);
  }

  /* ── Orden ────────────────────────────────────────────────────────────────────────── */
  function closeSorts(except) {
    $$('.ns-sortdd.open').forEach(function (d) {
      if (d === except) return;
      d.classList.remove('open');
      $('.ns-sortdd-toggle', d).setAttribute('aria-expanded', 'false');
    });
  }
  function pickSort(opt) {
    closeSorts();
    update({ sort_by: opt.dataset.value });
  }

  /* ── Eventos delegados (sobreviven a las sustituciones de HTML) ───────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var tgl = t.closest('.ns-sortdd-toggle');
    if (tgl && root.contains(tgl)) {
      var dd = tgl.closest('.ns-sortdd');
      closeSorts(dd);
      tgl.setAttribute('aria-expanded', String(dd.classList.toggle('open')));
      return;
    }
    var opt = t.closest('.ns-sortdd-list li');
    if (opt && root.contains(opt)) { pickSort(opt); return; }
    closeSorts();

    var v = t.closest('[data-ns-view]');
    if (v && root.contains(v)) {
      try { localStorage.setItem(VIEW_KEY, v.dataset.nsView); } catch (err) {}
      applyView(v.dataset.nsView);
      return;
    }
    var more = t.closest('[data-ns-more]');
    if (more && root.contains(more)) { e.preventDefault(); loadMore(more); return; }
    var link = t.closest('[data-ns-page], [data-ns-pill], [data-ns-clear]');
    if (link && root.contains(link)) {
      e.preventDefault();
      var u = new URL(link.href, location.origin);
      go(u.pathname + u.search, true);
      return;
    }
    var sm = t.closest('[data-ns-showmore]');
    if (sm && root.contains(sm)) {
      var group = sm.closest('details');
      var list = $('[data-ns-list]', group);
      if (list.classList.contains('is-expanded')) {
        list.classList.remove('is-expanded');
        $('[data-ns-more-label="more"]', sm).hidden = false;
        $('[data-ns-more-label="less"]', sm).hidden = true;
      } else expand(group);
      return;
    }
    if (t.closest('[data-ns-open-filters]')) { drawer(true); return; }
    if (t.closest('[data-ns-close-filters]') || t.closest('[data-ns-overlay]')) drawer(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSorts(); drawer(false); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.ns-sortdd-list li') && root.contains(e.target)) {
      e.preventDefault();
      pickSort(e.target);
    }
  });
  root.addEventListener('change', function (e) {
    if (!e.target.closest('[data-ns-filters]')) return;
    clearTimeout(timer);
    timer = setTimeout(update, 250);
  });
  root.addEventListener('submit', function (e) {
    if (!e.target.closest('[data-ns-filters]')) return;
    e.preventDefault();
    clearTimeout(timer);
    update();
    drawer(false);
  });
  window.addEventListener('popstate', function () { go(location.pathname + location.search, false); });

  applyView(storedView() || root.dataset.view);
})();
